// /* eslint-disable react/no-unstable-nested-components */
// /* eslint-disable no-unsafe-optional-chaining */
// /* eslint-disable no-undef */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useContext, useEffect, useRef, useState } from 'react'
// import { Card, CardBody, Col, Label, Row } from 'reactstrap'
// import Select from 'react-select';
// import DebounceTextInput from 'components/DebounseTextInput';
// import Heading from 'components/Heading';
// import { FSBTable } from 'components/common/FSBTable';
// import { axiosGetAPI } from 'services';
// import { authContext } from 'contexts/AuthContext'
// import { showSequenceNumber } from 'utils/constants';
// import { setUserDetails } from 'actions/userDetailsAction';
// import { useDispatch } from 'react-redux';
// import UserInfo from 'components/UserInfo';
// import moment from 'moment';

// const FeedbackHub = () => {
//   const feedbackColumns = [
//       { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
//       {
//         accessorKey: 'createdAt',
//         header: 'Date',
//         accessorFn: (row) => {
//           return row?.createdAt ? (
//               <div className="info">
//                   <h4 className="f-12 fw-medium mb-1 text-dark">
//                     {moment(new Date(row?.createdAt * 1000)).format('D MMM, YYYY')}
//                   </h4>
//                 </div>
//           ) : (
//             'N/A'
//           );
//         },
//         cell: (info) => info.getValue(),
//         enableSorting: false,
//       },
//       {
//         accessorKey: 'userId',
//         header: 'User ID',
//         enableSorting: false,
//       },
//     {
//         accessorKey: 'entityName',
//         header: 'User Name',
//         cell: ({ row }) => (
//         <UserInfo
//             name={row?.original?.entityName}
//             mobileNumber={`${row?.original?.callingCodeId}-${row?.original?.phone}`}
//           />
//         ),
//         enableSorting: false,
//       },
//       {
//         accessorKey: 'description',
//         header: 'Feedback Message',
//         enableSorting: false,
//         miSize: 400,
//         size: 400,
//         cell: ({ row }) => (
//           <div style={{background: 'white', textAlign: 'left'}}>
//               {row?.original?.description}
//           </div>
//         )
//       },

//     ]
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false)
//   const defaultFilters = {
//     pageNo: 1,
//     pageSize: 10,
//     totalPages: 0,
//     totalCount: 0,
//   }
//   const [filters, setFilters] = useState({...defaultFilters})
//   const [data, setData] = useState([])
//   const [options, setOptions] = useState([])
//   const defaultValue = {
//     id: 'all',
//     entityName: 'All'
//   }
//   const [selectedValue, setSelectedValue] = useState(defaultValue)
//   const [searchString, setSearchString] = useState("")
//   const { auth } = useContext(authContext);
//   const [refetch, setRefetch] = useState(false)
//   const abortControllerRef = useRef(null);

//   const fetchFeedbacks =async () => {
//     try {
//         if (abortControllerRef.current) {
//           abortControllerRef.current.abort();
//         }

//         setLoading(true)

//         const controller = new AbortController();
//         abortControllerRef.current = controller;

//         const pageNo = typeof filters?.pageNo === 'number' ? filters.pageNo : 1;
//         const pageSize = typeof filters?.pageSize === 'number' ? filters.pageSize : 10;
//         const params = new URLSearchParams();

//         params.append('size', pageSize);
//         params.append('page', pageNo - 1);

//         if (selectedValue?.id && selectedValue?.id !== 'all') {
//           params.append('userId', selectedValue.id);
//         }

//         if (searchString) {
//           params.append('search', searchString);
//         }
//         const resp = await axiosGetAPI(`${process.env.REACT_APP_REST_API_ENDPOINT}feedback?${params.toString()}`, auth, { signal: controller.signal })
//         if(resp?.isSuccessful) {
//           setLoading(false)
//           setData(resp?.data?.data?.content)
//           setFilters({
//             pageNo: typeof resp?.data?.data?.pageable?.pageNumber === 'number' ? resp.data.data.pageable.pageNumber + 1 : 1,
//             pageSize: resp?.data?.data?.pageable?.pageSize,
//             totalCount: resp?.data?.data?.totalElements,
//             totalPages: resp?.data?.data?.totalPages
//           })
//         } else if(resp?.message?.code === "ERR_CANCELED") {
//           setLoading(true)
//         } else {
//           setLoading(false)
//         }
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   useEffect(() => {
//     fetchFeedbacks()
//   }, [filters?.pageNo, filters?.pageSize, refetch])

//   useEffect(() => {
//       setFilters(
//         {
//           ...defaultFilters
//         }
//       );
//       setData([])
//       setRefetch(old => !old)
//   }, [searchString, selectedValue?.id])

//   const fetchUsers = async () => {
//     try {
//         const resp = await axiosGetAPI(`${process.env.REACT_APP_REST_API_ENDPOINT}feedback/users`, auth)
//         if(resp?.isSuccessful) {
//           setOptions([
//             { ...defaultValue },
//             ...(Array.isArray(resp?.data?.data) ? resp.data.data : [])
//           ])
//         } else {
//           setOptions([{ ...defaultValue }])
//         }
//     } catch (error) {
//       console.error(error)
//     }
//   }

//   useEffect(() => {
//     fetchUsers()
//   }, [])

//   const findIndexOfItem = (item) => {
//     return feedbackColumns.findIndex((itm) => itm.accessorKey === item);
//   };

//     const handleUserId = (row, id) => {
//       dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
//     };

//   const linkFormatterForUserId = (cell, userId) => {
//     return (
//       <div
//         className="text-blue-c5 fw-medium cursor-pointer"
//         onClick={() =>
//           handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
//         }
//         aria-hidden
//       >
//         {cell?.row?.original?.[userId]}
//       </div>
//     );
//   };

//   feedbackColumns[findIndexOfItem('SNo')].cell = (cell) =>
//       showSequenceNumber(cell, filters);

//   feedbackColumns[findIndexOfItem('userId')].cell = (cell) =>
//       linkFormatterForUserId(cell, 'userId');

//   const handlePageChange = ({ pageSize, pageNo }) => {
//     setData([])
//     setFilters({
//       ...filters,
//       pageNo,
//       pageSize,
//     });
//   };

//   return (
//    <div>
//       <div className="mb-3 pb-1 top-head">
//         <Heading title="User Feedback Hubs" description="Track and review all client feedback to improve platform experience and resolve concerns effectively." />
//       </div>
//       <Card className="border-0 card-box page-card-box">
//         <CardBody>
//            <div className="filter-row-ui">
//             <div className="form-group">
//               <Label>User name</Label>
//               <Select
//                 name="All"
//                 options={options}
//                 getOptionLabel={option => option?.entityName}
//                 getOptionValue={option => option?.id}
//                 placeholder="All"
//                 classNamePrefix="react-select"
//                 value={selectedValue}
//                 defaultValue={defaultValue}
//                 // defaultMenuIsOpen
//                 onChange={(value) => setSelectedValue(value)}
//               />
//             </div>

//             </div>
//             <Row>
//               <Col className="text-end" sm={6}>
//                 <DebounceTextInput
//                   onInputChange={value => setSearchString(value)}
//                   delay={500} // Set your desired delay in milliseconds
//                   value={searchString}
//                   classWrapper="right-search"
//                   placeholder="Search"
//                   positionTop="-30px"
//                   positionRight='20px'
//                 />
//               </Col>
//             </Row>
//             <FSBTable
//                     loading={loading}
//                     getRowId={(row) => row.id}
//                     data={data}
//                     totalCount={(filters.totalCount) || 0}
//                     totalPages={(filters?.totalPages) || 0}
//                     columns={feedbackColumns}
//                     currentPageNo={filters.pageNo}
//                     pageSize={filters.pageSize}
//                     keyField="id"
//                     showSearch={false}
//                     showFilters={false}
//                     showDelete={false}
//                     showPagination
//                     remote
//                     tableClass="action-table"
//                     striped={false}
//                     hover={false}
//                     bordered={false}
//                     wrapperClass="table-responsive word-break"
//                     handlePageChange={handlePageChange}
//                     // globalSearchStr={filters.filter[0].value}
//                     // onGlobalSearch={onGlobalSearch}
//                     onSortChange={() => {}}
//                     searchPlaceholder="Search Vendors"
//                     onSelectedRowsChange={() => {}}
//                     rowSelection={() => {}}
//                     getTableInstance={() => {}}
//                   />
//         </CardBody>
//       </Card>

//    </div>
//   )
// }

// export default FeedbackHub

/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Card, CardBody, Col, Label, Row } from 'reactstrap';
import Select from 'react-select';
import DebounceTextInput from 'components/DebounseTextInput';
import Heading from 'components/Heading';
import { FSBTable } from 'components/common/FSBTable';
import { axiosGetAPI } from 'services';
import { authContext } from 'contexts/AuthContext';
import { showSequenceNumber } from 'utils/constants';
import { setUserDetails } from 'actions/userDetailsAction';
import { useDispatch } from 'react-redux';
import DateFormatter from 'components/DateFormatter';

const FeedbackHub = () => {
  const [expandedCells, setExpandedCells] = useState({});

  const toggleExpandedCell = (cellKey) => {
    setExpandedCells((current) => ({
      ...current,
      [cellKey]: !current[cellKey],
    }));
  };

  const feedbackColumns = [
    { accessorKey: 'SNo', header: 'S.NO.', enableSorting: false },
    {
      accessorKey: 'createdAt',
      header: 'Date',
      size: 135,
      minSize: 135,
      cell: ({ row }) =>
        row?.original?.createdAt ? (
          <DateFormatter
            dateTime={row?.original?.createdAt}
            className="text-nowrap"
          />
        ) : (
          'N/A'
        ),
      enableSorting: false,
    },
    {
      accessorKey: 'userId',
      header: 'User ID',
      enableSorting: false,
    },
    {
      accessorKey: 'entityName',
      header: 'User Name',
      cell: ({ row }) => {
        const entityName = row?.original?.entityName || '';
        const callingCode = row?.original?.callingCodeId;
        const phone = row?.original?.phone;
        const mobileNumber = callingCode ? `${callingCode}-${phone}` : phone;
        const cellKey = `user-${row?.original?.id ?? row?.id}`;
        const isExpanded = Boolean(expandedCells[cellKey]);

        return (
          <div className="user-info d-flex align-items-center">
            <div className="info" style={{ width: '100%', minWidth: 0 }}>
              <button
                type="button"
                className="f-12 fw-medium mb-0 text-dark text-capitalize text-start border-0 bg-transparent p-0"
                aria-expanded={isExpanded}
                onClick={() => toggleExpandedCell(cellKey)}
                style={{
                  font: 'inherit',
                  display: 'block',
                  width: '100%',
                  overflow: isExpanded ? 'visible' : 'hidden',
                  textOverflow: isExpanded ? 'clip' : 'ellipsis',
                  whiteSpace: isExpanded ? 'normal' : 'nowrap',
                  overflowWrap: 'anywhere',
                  cursor: 'pointer',
                }}
              >
                {entityName}
              </button>
              {mobileNumber && (
                <p className="mb-0 mt-1 f-12 font-manrope text-active">
                  {mobileNumber}
                </p>
              )}
              {isExpanded && (
                <button
                  type="button"
                  className="btn btn-link p-0 mt-1 f-12"
                  onClick={() => toggleExpandedCell(cellKey)}
                >
                  Show less
                </button>
              )}
            </div>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: 'description',
      header: 'Feedback Message',
      enableSorting: false,
      miSize: 400,
      size: 400,
      cell: ({ row }) => {
        const description = row?.original?.description || '';
        const cellKey = `feedback-${row?.original?.id ?? row?.id}`;
        const isExpanded = Boolean(expandedCells[cellKey]);

        return (
          <div style={{ width: '400px', maxWidth: '100%', textAlign: 'left' }}>
            <button
              type="button"
              className="border-0 bg-transparent p-0 text-start"
              aria-expanded={isExpanded}
              onClick={() => toggleExpandedCell(cellKey)}
              style={{
                font: 'inherit',
                color: 'inherit',
                display: 'block',
                width: '100%',
                background: 'white',
                overflow: isExpanded ? 'visible' : 'hidden',
                textOverflow: isExpanded ? 'clip' : 'ellipsis',
                whiteSpace: isExpanded ? 'normal' : 'nowrap',
                overflowWrap: 'anywhere',
                cursor: 'pointer',
              }}
            >
              {description}
            </button>
            {isExpanded && (
              <button
                type="button"
                className="btn btn-link p-0 mt-1 f-12"
                onClick={() => toggleExpandedCell(cellKey)}
              >
                Show less
              </button>
            )}
          </div>
        );
      },
    },
  ];
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const defaultFilters = {
    pageNo: 1,
    pageSize: 10,
    totalPages: 0,
    totalCount: 0,
  };
  const [filters, setFilters] = useState({ ...defaultFilters });
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const defaultValue = {
    id: 'all',
    entityName: 'All',
  };
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [searchString, setSearchString] = useState('');
  const { auth } = useContext(authContext);
  const [refetch, setRefetch] = useState(false);
  const abortControllerRef = useRef(null);

  const fetchFeedbacks = async () => {
    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      setLoading(true);

      const controller = new AbortController();
      abortControllerRef.current = controller;

      const pageNo = typeof filters?.pageNo === 'number' ? filters.pageNo : 1;
      const pageSize =
        typeof filters?.pageSize === 'number' ? filters.pageSize : 10;
      const params = new URLSearchParams();

      params.append('size', pageSize);
      params.append('page', pageNo - 1);

      if (selectedValue?.id && selectedValue?.id !== 'all') {
        params.append('userId', selectedValue.id);
      }

      if (searchString) {
        params.append('search', searchString);
      }
      const resp = await axiosGetAPI(
        `${process.env.REACT_APP_REST_API_ENDPOINT}feedback?${params.toString()}`,
        auth,
        { signal: controller.signal },
      );
      if (resp?.isSuccessful) {
        setLoading(false);
        setData(resp?.data?.data?.content);
        setFilters({
          pageNo:
            typeof resp?.data?.data?.pageable?.pageNumber === 'number'
              ? resp.data.data.pageable.pageNumber + 1
              : 1,
          pageSize: resp?.data?.data?.pageable?.pageSize,
          totalCount: resp?.data?.data?.totalElements,
          totalPages: resp?.data?.data?.totalPages,
        });
      } else if (resp?.message?.code === 'ERR_CANCELED') {
        setLoading(true);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchFeedbacks();
  }, [filters?.pageNo, filters?.pageSize, refetch]);

  useEffect(() => {
    setFilters({
      ...defaultFilters,
    });
    setData([]);
    setRefetch((old) => !old);
  }, [searchString, selectedValue?.id]);

  const fetchUsers = async () => {
    try {
      const resp = await axiosGetAPI(
        `${process.env.REACT_APP_REST_API_ENDPOINT}feedback/users`,
        auth,
      );
      if (resp?.isSuccessful) {
        setOptions([
          { ...defaultValue },
          ...(Array.isArray(resp?.data?.data) ? resp.data.data : []),
        ]);
      } else {
        setOptions([{ ...defaultValue }]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const findIndexOfItem = (item) => {
    return feedbackColumns.findIndex((itm) => itm.accessorKey === item);
  };

  const handleUserId = (row, id) => {
    dispatch(setUserDetails({ status: true, selectedUser: { ...row, id } }));
  };

  const linkFormatterForUserId = (cell, userId) => {
    return (
      <div
        className="text-blue-c5 fw-medium cursor-pointer"
        onClick={() =>
          handleUserId(cell?.row?.original, cell?.row?.original?.[userId])
        }
        aria-hidden
      >
        {cell?.row?.original?.[userId]}
      </div>
    );
  };

  feedbackColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);

  feedbackColumns[findIndexOfItem('userId')].cell = (cell) =>
    linkFormatterForUserId(cell, 'userId');

  const handlePageChange = ({ pageSize, pageNo }) => {
    setData([]);
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };

  return (
    <div>
      <div className="mb-3 pb-1 top-head">
        <Heading
          title="User Feedback Hubs"
          description="Track and review all client feedback to improve platform experience and resolve concerns effectively."
        />
      </div>
      <Card className="border-0 card-box page-card-box">
        <CardBody>
          <div className="filter-row-ui">
            <div className="form-group">
              <Label>User name</Label>
              <Select
                name="All"
                options={options}
                getOptionLabel={(option) => option?.entityName}
                getOptionValue={(option) => option?.id}
                placeholder="All"
                classNamePrefix="react-select"
                value={selectedValue}
                defaultValue={defaultValue}
                onChange={(value) => setSelectedValue(value)}
              />
            </div>
          </div>
          <Row>
            <Col className="text-end" sm={6}>
              <DebounceTextInput
                onInputChange={(value) => setSearchString(value)}
                delay={500}
                value={searchString}
                classWrapper="right-search"
                placeholder="Search"
                positionTop="-30px"
                positionRight="20px"
              />
            </Col>
          </Row>
          <FSBTable
            loading={loading}
            getRowId={(row) => row.id}
            data={data}
            totalCount={filters.totalCount || 0}
            totalPages={filters?.totalPages || 0}
            columns={feedbackColumns}
            currentPageNo={filters.pageNo}
            pageSize={filters.pageSize}
            keyField="id"
            showSearch={false}
            showFilters={false}
            showDelete={false}
            showPagination
            remote
            tableClass="action-table"
            striped={false}
            hover={false}
            bordered={false}
            wrapperClass="table-responsive word-break"
            handlePageChange={handlePageChange}
            onSortChange={() => {}}
            searchPlaceholder="Search Vendors"
            onSelectedRowsChange={() => {}}
            rowSelection={() => {}}
            getTableInstance={() => {}}
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default FeedbackHub;
